import { useEffect, useState } from 'react';
import * as bd from 'react-basic-design';
import SvgAdd from '../../../assets/icons/Add';
import SvgDelete from '../../../assets/icons/Delete';
import SvgEdit from '../../../assets/icons/Edit';
import { T } from '../../../components/basic/text';
import { SysMenuTile } from '../../home/dashboard/sys-menu/tile';
import { tileIconTypes } from '../../home/dashboard/sys-menu/tile-icons';
import { SysMenuGroupsModal } from './sys-menu-groups-modal';
import { SysMenuModal } from './sys-menu-modal';
import { SysMenu, SysMenuGroup } from './sys-menu-types';
import { useMenuService } from './use-sys-menu-groups';
import { code } from '../../../components/basic/code';
import { Loading } from '../../../components/basic/loading';
import { InitFailed } from '../../../components/basic/init-failed';

export default function SysMenuGroupsApp() {
    const menuService = useMenuService();
    const [editGroupModalState, setEditGroupModalState] = useState<{
        show: boolean;
        group: SysMenuGroup;
    }>({ show: false, group: {} });

    const [editMenuModalState, setEditMenuModalState] = useState<{ show: boolean; menu: SysMenu }>({
        show: false,
        menu: { title: '' },
    });

    const onDeleteGroup = (values: any) => {
        bd.msgbox(<T>deleting-selected-group</T>, null, [
            {
                title: <T>delete</T>,
                action: (hide: () => void) => menuService.deleteSysMenuGroup(values.id, hide),
            },
            { title: <T>close</T> },
        ]);
    };

    const getTileIcon = (menu: any) => {
        if (!menu.iconCode) return null;
        const icons: any = tileIconTypes;
        const x: any = icons[menu.iconCode];
        if (!x) return null;
        return <span className="size-sm p-e-2">{x({ className: menu.iconCss })}</span>;
    };

    if (menuService.error)
        return <InitFailed ex={menuService.error} onRetry={menuService.loadSysMenuGroups} />;

    if (
        !menuService.initializedMenus ||
        menuService.initializingMenus ||
        !menuService.initializedMenuGroups ||
        menuService.initializingMenuGroups
    )
        return <Loading />;

    return (
        <>
            <div>
                <bd.Flex className="bg-gray-5 p-2">
                    <bd.Button
                        variant="contained"
                        className="m-e-1"
                        size="sm"
                        onClick={() => setEditGroupModalState({ show: true, group: {} })}
                    >
                        <T>add-group</T>
                        <SvgAdd />
                    </bd.Button>
                </bd.Flex>

                <div className="sys-menu flex-grow-1">
                    {menuService.groups?.map(g => {
                        const menus = menuService.menus?.filter(m => m.groupId === g.id);
                        return (
                            <div key={g.title} className="sys-menu-group">
                                <bd.Flex align="center">
                                    <span>{getTileIcon(g)} </span>
                                    <T as="h5" className="p-e-3 m-0">
                                        {g.title}
                                    </T>
                                    <small>({g.id})</small>
                                    <bd.Button
                                        size="sm"
                                        variant="icon"
                                        onClick={() =>
                                            setEditGroupModalState({ show: true, group: g })
                                        }
                                    >
                                        <SvgEdit />
                                    </bd.Button>
                                    <bd.Button
                                        size="sm"
                                        variant="icon"
                                        color="secondary"
                                        onClick={() => onDeleteGroup(g)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                </bd.Flex>
                                <bd.Flex className="tiles" wrap gap={2}>
                                    {menus.length > 0 && (
                                        <>
                                            {menus.map(m => (
                                                <SysMenuTile
                                                    key={m.id + m.title}
                                                    tile={{ ...m, indicator: 123 }}
                                                    onDesignClick={ev => {
                                                        code.stopPropagationFunc(ev);
                                                        setEditMenuModalState({
                                                            show: true,
                                                            menu: m,
                                                        });
                                                        return false;
                                                    }}
                                                    designMode
                                                />
                                            ))}
                                        </>
                                    )}
                                    <bd.Flex
                                        align="center"
                                        className="shadow-1 border rounded p-3 bg-primary-3"
                                    >
                                        <bd.Button
                                            onClick={() =>
                                                setEditMenuModalState({
                                                    show: true,
                                                    menu: { groupId: g.id, title: '' },
                                                })
                                            }
                                        >
                                            <T>add-tile-menu</T>
                                            <SvgAdd />
                                        </bd.Button>
                                    </bd.Flex>
                                </bd.Flex>
                            </div>
                        );
                    })}
                </div>
            </div>

            <SysMenuGroupsModal
                current={editGroupModalState.group}
                onHide={() => setEditGroupModalState({ ...editGroupModalState, show: false })}
                show={editGroupModalState.show}
                onSave={menuService.saveSysMenuGroup}
            />

            {editMenuModalState.show && (
                <SysMenuModal
                    show={editMenuModalState.show}
                    current={editMenuModalState.menu}
                    onHide={() => setEditMenuModalState({ ...editMenuModalState, show: false })}
                    onSave={(changedMenu, onHide) => menuService.saveSysMenu(changedMenu, onHide)}
                    onDelete={(menu, onHide) => menuService.deleteSysMenu(menu, onHide)}
                />
            )}
        </>
    );
}
